/* eslint-disable max-len */
import React from 'react';

import { FormattingIcon } from './../../ui-components';

const ArrowIcon = (props = {}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0196 5.07965C12.3125 4.78675 12.3125 4.31188 12.0196 4.01899C11.7267 3.72609 11.2518 3.72609 10.9589 4.01899L5.45893 9.51899L10.9589 15.0195C11.2518 15.3124 11.7267 15.3124 12.0196 15.0195C12.3125 14.7266 12.3125 14.2517 12.0196 13.9588L7.58025 9.51899L12.0196 5.07965Z"
      fill="currentColor"
    />
  </svg>
);

export const OrientationPluginIcon = (props: $TSFixMe) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <FormattingIcon />
      <ArrowIcon {...props} />
    </div>
  );
};
